<template>
  <div class="contentHome">
    <div class="center">
      <el-popover v-for="(obj,index) in photoWall" :key="index"
                  placement="right-start"
                  class="doctorImgList" width="400"
                  trigger="hover">
        <div slot="reference" @click="toDetail(obj.account)">
          <div class="doctor-img img" v-if="obj.headImgPath"
               :style="'backgroundImage: url('+obj.headImgPath+')'"></div>
          <div class="doctor-img img default-headImg" v-else :gender="obj.gender"></div>
        </div>
        <div class="doctor-detail">
          <div class="doctor-img img" v-if="obj.headImgPath"
               :style="'backgroundImage: url('+obj.headImgPath+')'"></div>
          <div class="doctor-img img default-headImg" v-else :gender="obj.gender"></div>
          <div class="right">
            <h3 class="overFlow">{{ obj.fullName }} {{ obj.enName }}</h3>
            <span class="medicineType">{{ obj.medicineType == 2 ? '心理医生' : '咨询师' }}</span>
            <p v-if="obj.company"><span>任职：</span>{{ obj.company }}{{ obj.technicalTitle }}</p>
            <p v-if="obj.professional"><span>专科：</span>{{ obj.professional }}</p>
            <p v-if="obj.skill"><span>擅长：</span>{{ obj.skill }}</p>
          </div>
        </div>
      </el-popover>
      <div class="remarks">
        <h2>期待您加入我们</h2>
        <p>每日研究更新 . 专业用药介绍 . 特例专家会议 </p>
      </div>
      <div style="clear: both"></div>
    </div>
    <div class="centerPage">
      <div class="left">
        <el-tabs value="全部" class="tabs" @tab-click="handleClick">
          <el-tab-pane :name="obj" :label="obj" v-for="(obj,ind) in consultJson" :key="ind">
            <div class="typeHead">
              <div class="medicineType flex city-box">
                <span class="typeTit">所在城市：</span>
                <div class="medicineTypeL city" id="city-list" :isOpen="cityMore.open">
                  <span>
                      <label :class="cityActive==0?'activeClass':''" @click="changeCity(0)">不限 </label>
                  </span>
                  <!--循环内容-->
                  <span v-for="(item,index) in cityList" :key="index">
                      <label :class="cityActive==index+1?'activeClass':''"
                             @click="changeCity(index+1,item)">{{ item.cnName }}</label>
                  </span>
                </div>
                <span class="city-more" v-if="cityMore.show"
                      @click="toggleCityBox">{{ cityMore.open ? '收起' : '更多' }}</span>
              </div>

              <div class="medicineType flex city-box">
                <span class="typeTit">科室：</span>
                <div class="medicineTypeL city" id="tags-list" :isOpen="tags.open">
                  <span>
                      <label :class="tags.active==0?'activeClass':''" @click="changeTags(0)">不限 </label>
                  </span>
                  <!--循环内容-->
                  <span v-for="(item,index) in tags.list" :key="index">
                      <label :class="tags.active==index+1?'activeClass':''" @click="changeTags(index+1,item)">{{
                          item
                        }}</label>
                  </span>
                </div>
                <span class="city-more" v-if="tags.show" @click="toggleTagBox">{{ tags.open ? '收起' : '更多' }}</span>
              </div>

              <div class="medicineType flex city-box">
                <span class="typeTit">服务类型：</span>
                <div class="medicineTypeL city" id="type-list" :isOpen="typeMore.open">
                  <span><label :class="indicationActive==0?'activeClass':''"
                               @click="changeIndication(0)">不限</label></span>
                  <!--循环内容-->
                  <span v-for="(item,index) in indicationList" :key="index">
                      <label :class="indicationActive==index+1?'activeClass':''"
                             @click="changeIndication(index+1,item.id)">{{ item.cnName }}</label>
                  </span>
                </div>
                <span class="city-more" v-if="typeMore.show"
                      @click="toggleTypeBox">{{ typeMore.open ? '收起' : '更多' }}</span>
              </div>

              <div class="medicineType flex">
                <span class="typeTit">咨询方式：</span>
                <div class="medicineTypeL">
                  <!--                  <span><label :class="modeActive==0?'activeClass':''"
                                                 @click="changeMode(0)">不限</label></span>
                                        &lt;!&ndash;循环内容&ndash;&gt;
                                        <span v-for="(item,index) in modeList" :key="index">
                                            <label :class="modeActive==index+1?'activeClass':''"
                                                   @click="changeMode(index+1)">{{item}}</label>
                                        </span>-->
                  <span>
                      <label :class="modeActive==0?'activeClass':''" @click="changeMode(0)">不限</label>
                  </span>
                  <span>
                      <label :class="modeActive==1?'activeClass':''" @click="changeMode(1)">语音咨询</label>
                  </span>
                  <span>
                      <label :class="modeActive==2?'activeClass':''" @click="changeMode(2)">视频咨询</label>
                  </span>
                </div>
              </div>
            </div>
            <div class="medicineType flex">
              <span :class="tagActive==0?'activeClass':''" class="flex" @click="changeTag(0)">
                <label>不限</label>
              </span>
              <span :class="tagActive==2?'activeClass':''" class="flex" @click="changeTag(2)">
                <img src="../../assets/img/d_type_01.png" alt="">
                <label>心理医生</label>
              </span>
              <span :class="tagActive==1?'activeClass':''" class="flex" @click="changeTag(1)">
                <img src="../../assets/img/d_type_02.png" alt="">
                  <label>咨询师</label>
              </span>
            </div>
            <div class="leftCon">
              <div v-if="famousDoctorList.length==0" style="text-align: center;color: #DFE0E7;width: 100%">
                <img src="../../assets/img/empty_tips.png" alt="" style="width: 320px;">
                <div>暂无数据</div>
              </div>
              <div v-else class="userList flex" v-for="(obj,index) in famousDoctorList" :key="index">
                <div v-if="obj.headImgPath" @click="toDetail(obj.account)" class="objImg img"
                     :style="'backgroundImage: url('+obj.headImgPath+')'">
                  <div class="tags img" :type="obj.medicineType"></div>
                </div>
                <div v-else @click="toDetail(obj.account)"  class="objImg img default-headImg" :gender="obj.gender">
                  <div class="tags img" :type="obj.medicineType"></div>
                </div>
                <div class="right">
                  <div @click="toDetail(obj.account)"  style=" cursor: pointer;">
                    <div class="flex">
                      <h2>{{ obj.fullName }} {{ obj.enName }}</h2>
                      <span class="serviceLength"
                            v-html="obj.age===0?'今年从业':('从业<strong>'+obj.age+'</strong></span>年')"></span>
                    </div>
                    <span class="count">已咨询<strong>{{ obj.supplement.consultationCount }}</strong>人</span>
                    <div style="clear:both;"></div>
                    <p class="post">{{ obj.company }}{{ obj.technicalTitle }}</p>
                    <p class="motto">{{ obj.signature }}</p>
                    <span v-if="obj.languages" class="language-tag">{{ obj.languages.join('/') }}</span>
                  </div>
                  <div class="flex" style="justify-content: space-between;width: 100%;">
                    <span class="pay">
                      <template v-if="obj.isOpenAppoint===0">
                         预约即将开启
                      </template>
                     <template v-else>
                        {{ obj.initialCharge }}元 / {{ obj.initialMinute }}分钟
                     </template>
                       <template v-if="obj.supplement.specialNote">（{{ obj.supplement.specialNote }}）</template>
                    </span>
                    <div>
                      <el-button @click="toDetail(obj.account)">主页</el-button>
                      <shortChat :user-id="obj.id" :username="obj.fullName" style="margin-right: 12px" v-if="getUserId && getUserId != obj.id" @handleNeedApply="showApplyDialog"></shortChat>
                    </div>
                    <!--<span class="reservation" v-if="obj.appointTimeSlot=='true'">本周预约已满</span>-->
                  </div>
                </div>
              </div>
              <!--分页-->
              <el-pagination
                  :hide-on-single-page="true"
                  class="pagination"
                  background
                  prev-text="Prev"
                  next-text="Next"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  layout="prev, pager, next, total"
                  :total="total">
              </el-pagination>
            </div>

          </el-tab-pane>
        </el-tabs>
        <el-input class="addART"
                  placeholder="搜索医生名字"
                  v-model="search" suffix-icon="el-icon-search" @change="changeName()">
        </el-input>
      </div>
      <div class="doctorRes">
        <el-button class="resBtn" @click="$refs.commonRes.registrationMethod=true">医生注册</el-button>
        <div class="newDoctor">
          <p class="tit">美国注册医生</p>
          <div class="userList flex" v-for="(obj,index) in teamDoctorList" :key="index"
               @click="toDoctorIndex(obj.account)" style="cursor: pointer" v-show="isOpen || index < max">
            <div class="objImg img" :style="'backgroundImage: url('+obj.headImgPath+')'"></div>
            <div class="right doctor-info">
              <h4>{{ obj.fullName }}</h4>
              <h5>{{ obj.enName }}</h5>
              <p class="motto overFlow">{{ obj.company }}{{ obj.technicalTitle }}</p>
              <span class="pay" v-if="!obj.initialCharge"></span>
              <span class="pay" v-else-if="obj.initialCharge&&obj.chargeType==1">{{ obj.initialCharge }}元 / 次</span>
              <span class="pay" v-else-if="obj.initialCharge&&obj.chargeType==2">{{
                  obj.initialCharge
                }}元 / {{ obj.initialMinute }}分钟</span>
            </div>
          </div>
          <p class="moreCheck" v-show="!isOpen && teamDoctorList.length > max" @click="isOpen = !isOpen">展开更多</p>
          <p class="moreCheck" v-show="isOpen && teamDoctorList.length > max" @click="isOpen = !isOpen">收起</p>
        </div>
        <hr style='background-color:#567BFF; height:1px; border:none;'>
        <div class="newDoctor">
          <p class="tit">中国注册医生</p>
          <div class="userList flex" v-for="(obj,index) in newDoctorList" :key="index"
               @click="toDoctorIndex(obj.account)" style="cursor: pointer">

            <div v-if="obj.headImgPath" class="objImg img" :style="'backgroundImage: url('+obj.headImgPath+')'"></div>
            <div v-else class="objImg img default-headImg" :gender="obj.gender"></div>

            <div class="right doctor-info">
              <h4>{{ obj.fullName }}</h4>
              <h5>{{ obj.enName }}</h5>
              <p class="motto overFlow">{{ obj.company }}{{ obj.technicalTitle }}</p>
              <span class="pay" v-if="!obj.initialCharge"></span>
              <span class="pay" v-else-if="obj.initialCharge&&obj.chargeType==1">{{ obj.initialCharge }}元/次</span>
              <span class="pay" v-else-if="obj.initialCharge&&obj.chargeType==2">{{
                  obj.initialCharge
                }}元 / {{ obj.initialMinute }}分钟</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    悬浮框-->
    <suspensionDrawer></suspensionDrawer>

    <commonRes ref="commonRes"></commonRes>

    <el-dialog class="buddy"
               top="0"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="friendApplyDialog.show"
               width="340px" >
      <template slot="title">
        <span>好友申请</span>
      </template>
      <div v-if="friendApplyDialog.form.name" style="font-size: 14px; font-weight: bold;margin-bottom: 8px">
        请求添加“{{friendApplyDialog.form.name}}”为好友
      </div>
      <el-input v-model="friendApplyDialog.form.reason" type="textarea" rows="4" placeholder="请输入请求内容"></el-input>
      <template slot="footer">
        <el-button type="primary" @click="sendFriendApply" :loading="friendApplyDialog.btnLoad">发送申请</el-button>
        <el-button style="margin-left: 18px" @click="friendApplyDialog.show=false">取消</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import commonjs from "@/api/common"
import commonRes from './commonRes'
import shortChat from "../common/shortChat";
import suspensionDrawer from '../suspensionDrawer'

export default {
  name: "famousDoctor",
  data() {
    return {
      search: '',//搜索
      consultJson: ['全部'],
      activeName: '0',//全部我的
      getUserId: '',//当前用户id

      newDoctorList: [],//右侧最新加入的专家栏
      teamDoctorList: [],// 右侧专家团队
      famousDoctorList: [],//著名专家

      photoWall: [],//照片墙

      cityList: [],//所有所在在城市
      cityActive: 0,

      appTimeActive: 0,

      indicationList: {},//所有服务类型
      indicationActive: 0,

      modeActive: 0,//咨询方式

      getFamousDoctorsUrl: commonjs.api.famousDoctor.conditionPage,//著名专家链接

      getCondition: {
        abodeCity: '',//所在城市
        abodeCityEn: '',//所在城市
        appointTimeSlot: '',//可约时间
        consultMode: '',//咨询方式
        indicationId: '',//服务类型
        fullName: '',//医生名字
        userId: '',//当前用户id
        tagName: '',// 标签
        tagType: 1,// 科室标签
        excludeCloseAppoint: 0,
        isConcern: false,
        medicineType: 0
      },//查询条件
      currentPage: 1,// 当前页
      pageSize: 5,// 每页多少条
      total: 0,//该标签文章总数
      isOpen: false,
      max: 5,

      cityMore: {
        show: false,
        open: false,
      },

      tags: {
        list: [],
        active: 0,
        show: false,
        open: false
      },

      typeMore: {
        show: false,
        open: false
      },

      tagActive: 0,
      // 好友申请弹窗
      friendApplyDialog: {
        show: false,
        btnLoad: false,
        form: {
          id: '',
          name: '',
          reason: ''
        }
      }

    }
  },
  async mounted() {
    let currentUser = await commonjs.utils.getCurrent();//获取当前登录的用户id
    if (currentUser != null) {
      this.getUserId = currentUser.id;
    }
    this.getUser();//当前用户
    this.getCity();//所在城市
    this.getIndication();//服务类型
    this.getNewDoctors();//最新加入的专家
    this.getPhotoWall();//照片墙
    this.getFamousDoctors();//著名专家

    // 右侧专家团队
    this.$ajax.get(commonjs.api.doctor.teamList).then(res => {
      if (res.data.status === 'success') {
        this.teamDoctorList = res.data.list;
      }
    });
    // 科室信息
    let that = this;
    that.$ajax.get(commonjs.api.famousDoctor.department_tags).then(res => {
      if (res.data.status === 'success') {
        that.tags.list = res.data.list;
        that.$nextTick(() => {
          let tag_show_height = $('#tags-list').height();
          let tag_real_height = document.getElementById('tags-list').scrollHeight;
          if (tag_show_height < tag_real_height) { //存在隐藏内容
            that.tags.show = true;
          }
        });
      }
    });
  },
  methods: {
    showApplyDialog(userId,userName){
      this.friendApplyDialog.form.id = userId;
      this.friendApplyDialog.form.name = userName;
      this.friendApplyDialog.btnLoad = false;
      this.friendApplyDialog.show = true;
    },
    sendFriendApply(){
      let userId = this.friendApplyDialog.form.id;
      if(!userId){ return; }
      let greetContent = this.friendApplyDialog.form.reason;
      if($.trim(greetContent).length===0){
        this.$message.error('好友申请内容不能为空');return;
      }
      this.friendApplyDialog.btnLoad = true;
      this.$ajax.post(commonjs.api.communication.chat.applySubmit.replace('{id}', userId), {greetContent}).then(res=>{
        this.friendApplyDialog.btnLoad = false;
        if(res.data.status === 'success'){
          this.$message.success('已发送');
          this.friendApplyDialog.show = false;
        }else{
          this.$message.error(res.data.message);
        }
      }).catch(err=>{
        this.$message.error('error');
        this.friendApplyDialog.btnLoad = false;
      });
    },
    toggleCityBox() {
      this.cityMore.open = !this.cityMore.open;
    },
    toDetail(account) {
      this.$router.push({path: '/' + account})
    },

    //获取最新的专家
    getNewDoctors() {
      let vm = this;
      let condition = {
        country: '中国',
        current: 1,
        size: 5,
        orderByNewest: 1
      };
      this.$ajax.post(commonjs.api.doctor.condition, condition).then(res => {
        if (res.data.status === 'success') {
          vm.newDoctorList = res.data.rows;
        }
      })

    },
    // 照片墙
    getPhotoWall() {
      let vm = this, url;
      url = vm.getFamousDoctorsUrl + '/' + 33;
      this.$ajax.post(url).then(function (res) {
        if (res.data.status === 'success') {
          vm.photoWall = res.data.rows;
        }
      })
    },
    //获取著名专家
    getFamousDoctors() {
      let vm = this, url;
      if (!vm.getCondition.isConcern) { // 全部
        url = vm.getFamousDoctorsUrl;
      } else { // 我的
        url = commonjs.api.famousDoctor.concernPage;
      }
      let data = {
        name: vm.search,
        abodeCity: vm.getCondition.abodeCity,
        indicationId: vm.getCondition.indicationId,
        consultMode: vm.getCondition.consultMode,
        current: vm.currentPage,
        size: vm.pageSize,
        tagName: vm.getCondition.tagName,
        tagType: vm.getCondition.tagType,
        medicineType: vm.getCondition.medicineType,
      };
      this.$ajax.post(url, data).then(function (res) {
        if (res.data.status === 'success') {
          $(res.data.rows).each((i, item) => {
            // 时间处理
            item.age = new Date().getFullYear() - new Date(item.startWorkDate).getFullYear();
            // supplement处理
            if (item.supplement) {
              item.chargeType = item.supplement.chargeType;
              item.initialCharge = item.supplement.initialCharge;
              item.initialMinute = item.supplement.initialMinute;
              item.furtherCharge = item.supplement.furtherCharge;
              item.furtherMinute = item.supplement.furtherMinute;
              item.signature = item.supplement.signature;
            }
          });
          vm.famousDoctorList = res.data.rows;
          vm.total = res.data.total;
        }
      })
    },

    getCity() {
      //获得专家所在城市
      let vm = this;
      this.$ajax.get(commonjs.api.famousDoctor.city_group).then(res => {
        if (res.data.status === 'success') {
          $(res.data.list).each((i, o) => {
            vm.cityList.push({cnName: o, enName: ''});
          });
          vm.$nextTick(() => {
            let city_show_height = $('#city-list').height();
            let city_real_height = document.getElementById('city-list').scrollHeight;
            if (city_show_height < city_real_height) { //存在隐藏内容
              vm.cityMore.show = true;
            }
          });
        }
      });

    },
    //改变所在城市
    changeCity(index, item) {
      this.cityActive = index;
      this.getCondition.abodeCity = '';
      this.getCondition.abodeCityEn = '';
      this.currentPage = 1;
      if (item) {
        this.getCondition.abodeCity = item.cnName;
        if (item.enName) {
          this.getCondition.abodeCityEn = item.enName;
        }
      }
      this.getFamousDoctors();
    },
    //改变可预约时间
    changeAppTime(index, id) {
      this.appTimeActive = index;
      this.getCondition.appointTimeSlot = id;
      this.currentPage = 1;
      this.getFamousDoctors();
    },
    //获取服务类型
    getIndication() {
      let vm = this;
      this.$ajax.get(commonjs.api.famousDoctor.indication).then(function (res) {
        if (res.data.status === 'success') {
          vm.indicationList = res.data.list;
          vm.$nextTick(() => {
            let type_show_height = $('#type-list').height();
            let type_real_height = document.getElementById('type-list').scrollHeight;
            if (type_show_height < type_real_height) { //存在隐藏内容
              vm.typeMore.show = true;
            }
          });
        }
      })
    },
    //改变服务类型
    changeIndication(index, id) {
      this.indicationActive = index;
      this.getCondition.indicationId = id;
      this.currentPage = 1;
      this.getFamousDoctors();
    },
    //改变咨询方式
    changeMode(index) {
      this.modeActive = index;
      this.getCondition.consultMode = index;
      this.currentPage = 1;
      this.getFamousDoctors();
    },
    // 搜索医生类型
    changeTag(type) {
      this.tagActive = type;
      this.getCondition.medicineType = type;
      this.currentPage = 1;
      this.getFamousDoctors();
    },
    //搜索名字
    changeName() {
      this.currentPage = 1;
      this.getCondition.fullName = this.search;
      this.getFamousDoctors();
    },
    // 每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
    },
    // 当前页  根据标签页分别执行传输
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getFamousDoctors();
      this.$nextTick(() => {
        $(".contentIndex").animate({scrollTop: '0px'}, 800);
      });
    },
    //全部/我的 点击事件
    handleClick(tab) {
      this.currentPage = 1;
      if (tab.name === "我的关注") {
        this.getCondition.userId = this.getUserId;
        this.getCondition.isConcern = true;
      } else {
        this.getCondition.userId = null;
        this.getCondition.isConcern = false;
      }
      this.getFamousDoctors();
    },
    //获得当前用户id
    getUser() {
      if (this.getUserId) {
        this.consultJson = ['全部', '我的关注']
      } else {
        this.consultJson = ['全部']
      }
    },
    toDoctorIndex(account) {
      this.$router.push({path: '/' + account})
    },
    changeTags(index, item) {
      this.tags.active = index;
      this.currentPage = 1;
      this.getCondition.tagName = item;
      this.getFamousDoctors();
    },
    toggleTagBox() {
      this.tags.open = !this.tags.open;
    },
    toggleTypeBox() {
      this.typeMore.open = !this.typeMore.open;
    }
  },
  components: {
    commonRes, shortChat, suspensionDrawer
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/famousDoctor.scss';
.buddy ::v-deep {
  .el-dialog {
    margin-bottom: 0;
  }
  .el-dialog__header {
    font-size: 16px;
    font-family: Microsoft YaHei UI;
    font-weight: bold;
    color: #567BFF;
    border-bottom: 1px solid rgba(187, 187, 187, 0.5);
    span {
      border-bottom: 2px solid #567BFF;
      padding-bottom: 10px;
    }
  }
  .el-dialog__body {
    padding: 15px 20px;
  }
  .el-dialog__close {
    border: 1px dashed #567BFF;
    color: #567BFF;
    font-size: 18px;
  }
  button{
    padding: 0 12px;
    height: 34px;
    line-height: 34px;
  }
}
</style>
